import { useEffect, useRef, useState } from "react";
import "./Contact_us.css";
import Form from "react-bootstrap/Form";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Success_Modal from "../common-components/common_Modal/success_modal/Success_Modal";
import emailjs from "emailjs-com";
import { useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { postData } from "../../utils/api";

const Contact_us = () => {
  const {
    control,
    register,
    formState: { errors },
    reset,
    handleSubmit,
  } = useForm({
    mode: "onBlur",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [modalShow, setModalShow] = useState(false);

  const [phoneValue, setPhoneValue] = useState("");

  function handleClick(el) {
    el.classList.toggle("float-label-top");
  }

  const form = useRef();

  const navigate = useNavigate();

  const onSubmit = async (data) => {
    data.subject = "dummy";
    const res = await postData("/contact/save", data);

    if (res.success) {
      reset();
      setModalShow(true);
      setTimeout(() => {
        // navigate("/");
        setModalShow(false);
      }, 3500);
    } else {
      alert("Something Went Wrong!");
    }
  };

  //   const onSubmit = async (data) => {
  //     console.log("Form submitted with:", data);

  //     const htmlFormat = ` <div style="font-family: Arial, sans-serif; color: #333; padding: 20px; border: 1px solid #eee; border-radius: 8px; max-width: 600px; margin: auto;">
  //           <h2 style="color: #4CAF50; border-bottom: 2px solid #4CAF50; padding-bottom: 8px;">
  //             📩 New Contact Form Submission
  //           </h2>
  //           <p style="font-size: 16px; margin: 10px 0;">You’ve received a new enquiry from your website:</p>
  //           <table style="width: 100%; border-collapse: collapse; margin-top: 15px;">
  //             <tr>
  //               <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Name</td>
  //               <td style="padding: 10px; border: 1px solid #ddd;">${data.fullName}</td>
  //             </tr>
  //             <tr>
  //               <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Email</td>
  //               <td style="padding: 10px; border: 1px solid #ddd;">${data.email}</td>
  //             </tr>
  //              <tr>
  //               <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Contact Number</td>
  //               <td style="padding: 10px; border: 1px solid #ddd;">${data.phone}</td>
  //             </tr>
  //              <tr>
  //               <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">City</td>
  //               <td style="padding: 10px; border: 1px solid #ddd;">${data.city}</td>
  //             </tr>
  //             <tr>
  //               <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Message</td>
  //               <td style="padding: 10px; border: 1px solid #ddd;">${data.message}</td>
  //             </tr>
  //           </table>
  //         </div>`;

  //     try {
  //       const payload = {
  //         email: "Shrikantmasule08@gmail.com",
  //         subject: `Support Request: ${data.fullName}`,
  //         html: htmlFormat,
  //         key: "Profcyma",
  //       };

  //       const response = await fetch(
  //         "https://emailservices.hostelbliss.com:3301/common-email",
  //         {
  //           method: "POST",
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //           body: JSON.stringify(payload),
  //         },
  //       );

  //       const result = await response.json();

  //       if (response.ok) {
  //         setModalShow(true);
  //         setTimeout(() => {
  //           navigate("/");
  //           setModalShow(false);
  //         }, 3500);
  //       } else {
  //         console.error("Form submission failed:", result);
  //       }
  //     } catch (error) {
  //       console.error("Submission error:", error);
  //     }
  //   };

  const [isFlipped, setIsFlipped] = useState(false);

  const handleImageClick = () => {
    setIsFlipped(!isFlipped);
  };
  return (
    <>
      <section className="Contact_us_section">
        <div className="container">
          <div
            className={`flip-card ${
              isFlipped ? "flipped" : "" || isFlipped ? "" : ""
            } `}
          >
            <div className="main_sec">
              <div className="form_sec">
                <div className="row">
                  <div className="col-lg-6 order-lg-1 order-2">
                    <div className="contform">
                      <p className="cont_title">Contact us</p>
                      <h3 className="feelh6">Feel Free to Contact Us</h3>

                      <Form
                        className="mt-4"
                        onSubmit={handleSubmit(onSubmit)}
                        noValidate
                      >
                        {/* FULL NAME */}
                        <Form.Group className="form-group">
                          <Form.Control
                            type="text"
                            placeholder="Enter Full Name*"
                            {...register("name", {
                              required: "Full name is required",
                              minLength: {
                                value: 3,
                                message: "Name must be at least 3 characters",
                              },
                            })}
                            className={errors.name ? "is-invalid" : ""}
                          />
                          {errors.name && (
                            <div className="invalid-feedback d-block">
                              {errors.name.message}
                            </div>
                          )}
                        </Form.Group>

                        {/* EMAIL */}
                        <Form.Group className="form-group">
                          <Form.Control
                            type="email"
                            placeholder="Enter Email*"
                            {...register("email", {
                              required: "Email is required",
                              pattern: {
                                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                message: "Enter a valid email address",
                              },
                            })}
                            className={errors.email ? "is-invalid" : ""}
                          />
                          {errors.email && (
                            <div className="invalid-feedback d-block">
                              {errors.email.message}
                            </div>
                          )}
                        </Form.Group>

                        {/* PHONE NUMBER */}
                        <Form.Group className="form-group">
                          <Controller
                            name="contact_no"
                            control={control}
                            rules={{
                              required: "Contact number is required",
                              minLength: {
                                value: 10,
                                message: "Enter a valid contact number",
                              },
                            }}
                            render={({ field }) => (
                              <>
                                <PhoneInput
                                  country={"in"}
                                  enableSearch
                                  value={field.value}
                                  onChange={field.onChange}
                                  inputProps={{
                                    name: "contact_no",
                                    placeholder: "Enter Contact Number*",
                                  }}
                                  inputClass={
                                    errors.contact_no ? "is-invalid" : ""
                                  }
                                />
                                {errors.contact_no && (
                                  <div className="invalid-feedback d-block">
                                    {errors.contact_no.message}
                                  </div>
                                )}
                              </>
                            )}
                          />
                        </Form.Group>

                        {/* MESSAGE */}
                        <Form.Group className="form-group">
                          <FloatingLabel label="">
                            <Form.Control
                              as="textarea"
                              placeholder="Write your message here*"
                              style={{ height: "100px" }}
                              {...register("message", {
                                required: "Message is required",
                              })}
                              className={errors.message ? "is-invalid" : ""}
                            />
                          </FloatingLabel>
                          {errors.message && (
                            <div className="invalid-feedback d-block">
                              {errors.message.message}
                            </div>
                          )}
                        </Form.Group>

                        {/* SUBMIT BUTTON */}
                        <Form.Group className="form-group text-center">
                          <button className="submit-button" type="submit">
                            Submit
                          </button>
                        </Form.Group>
                      </Form>
                    </div>
                  </div>
                  <div className="col-lg-6 order-lg-2 order-1">
                    <div className="contdetails">
                      <img
                        className="contimg"
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/contact-us/contbaner.png"
                        }
                      />

                      <div className="phonemsec">
                        <div className="row">
                          <div className="col-lg-6 mb-3">
                            <a
                              className="contact-us-anchor"
                              href="tel:+916262171723"
                            >
                              <div className="det_box">
                                <div className="icondiv">
                                  <img
                                    className="icon"
                                    src={
                                      process.env.PUBLIC_URL +
                                      "/assets/images/contact-us/call.png"
                                    }
                                  />
                                </div>
                                <div className="detaildiv">
                                  <p className="det_title">Phone</p>
                                  <p className="det_text">+91 6262171723</p>
                                </div>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-6 mb-3">
                            <a
                              className="contact-us-anchor"
                              href="mailto:Shrikantmasule08@gmail.com"
                            >
                              <div className="det_box">
                                <div className="icondiv">
                                  <img
                                    className="icon"
                                    src={
                                      process.env.PUBLIC_URL +
                                      "/assets/images/contact-us/email.png"
                                    }
                                  />
                                </div>
                                <div className="detaildiv">
                                  <p className="det_title">Email</p>
                                  <p className="det_text">
                                    admin@loconextech.com
                                  </p>
                                </div>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-12">
                            <div className="det_box">
                              <div className="icondiv">
                                <img
                                  className="icon"
                                  src={
                                    process.env.PUBLIC_URL +
                                    "/assets/images/contact-us/location.png"
                                  }
                                />
                              </div>
                              <div className="detaildiv adreeposition">
                                <p className="det_title">Address</p>
                                <p className="det_text">
                                  A/P Tembhurni, Sathe Nagar, Tal-Madha,
                                  Dist-Solapur, Maharashtra, India
                                </p>

                                <p
                                  className="findmap"
                                  onClick={handleImageClick}
                                >
                                  Find Us on Map
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flip-card-back">
                <div className="map-section">
                  <div className="mapouter">
                    <div className="gmap_canvas">
                      <iframe
                        className="gmap_iframe"
                        frameBorder="0"
                        scrolling="no"
                        marginHeight="0"
                        marginWidth="0"
                        src="https://maps.google.com/maps?q=18.037624507169433,75.19679697496412&z=15&output=embed"
                      ></iframe>
                      <a href="https://pdflist.com/" alt="pdflist.com"></a>
                    </div>
                  </div>

                  <img
                    onClick={handleImageClick}
                    className="close-map-icon"
                    src={
                      process.env.PUBLIC_URL +
                      "/assets/images/contact-us/close.png"
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Success_Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        successText="Submited Sucessfully"
      />
    </>
  );
};

export default Contact_us;
